import { render, staticRenderFns } from "./UploadTrustPhoto.vue?vue&type=template&id=63a13c8e&scoped=true&"
import script from "./UploadTrustPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadTrustPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadTrustPhoto.vue?vue&type=style&index=0&id=63a13c8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a13c8e",
  null
  
)

export default component.exports